import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEventIfConsented } from './analyticsConsent';

const SEARCH_HUB_PATHS = [
  '/desk-setup-ideas',
  '/minimalist-desk-setup',
  '/home-office-desk-setup',
  '/desk-lighting-ideas',
  '/monitor-arm-desk-setup',
  '/how-to-hide-cables-on-a-desk',
];
const LEGAL_PAGE_PATHS = ['/legal', '/privacy', '/cookies', '/terms', '/affiliate-disclosure'];

export const getPageGroupFromPath = pathname => {
  if (!pathname || pathname === '/') {
    return 'home';
  }

  if (SEARCH_HUB_PATHS.includes(pathname)) {
    return 'search_hub';
  }

  if (pathname.startsWith('/setup-ideas/')) {
    return 'topic_hub';
  }

  if (pathname.startsWith('/collections/')) {
    return 'collection_page';
  }

  if (pathname.startsWith('/gear/')) {
    return 'gear_page';
  }

  if (pathname.startsWith('/setup/')) {
    return 'setup_page';
  }

  if (pathname === '/latest') {
    return 'latest_page';
  }

  if (pathname === '/ImgDropAndCrop') {
    return 'upload_page';
  }

  if (pathname === '/login') {
    return 'auth_page';
  }

  if (LEGAL_PAGE_PATHS.includes(pathname)) {
    return 'legal_page';
  }

  return 'unknown';
};

export const trackInternalNavigationIfConsented = ({
  link_target,
  link_context,
  source_page_group,
  destination_page_group,
  ...rest
} = {}) =>
  trackEventIfConsented('internal_navigation_click', {
    link_target,
    link_context,
    source_page_group,
    destination_page_group,
    ...rest,
  });

export const usePageGroupTracking = (pageGroup, extraParams = {}) => {
  const location = useLocation();
  const serializedExtraParams = JSON.stringify(extraParams);

  useEffect(() => {
    const parsedExtraParams = serializedExtraParams ? JSON.parse(serializedExtraParams) : {};

    trackEventIfConsented('view_page_group', {
      page_group: pageGroup,
      page_path: location.pathname,
      ...parsedExtraParams,
    });
  }, [serializedExtraParams, location.pathname, pageGroup]);
};
